import * as React from "react"
import { Link as GatsbyRouter } from "gatsby"
import { FiMenu } from "react-icons/fi"
import { IconButton, Flex, Link, Box, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react"
import { BREAKPOINTS } from "../../utils/constants"

export default function PageLayout({ children }) {
  return (
    <>
      <Flex
        position="sticky"
        height="60px"
        bg="white"
        top={0}
        w="100%"
        alignItems="center"
        justifyContent="space-between"
        py="4px"
        px={["4px", "8px", "16px"]}
        borderBottom="1px solid"
        borderColor="gray.700"
        zIndex={10}
        m="auto"
      >
        <Link as={GatsbyRouter} to="/">
          <UrutauLogo />
        </Link>
        <Box display={["none", "none", "inline"]}>
          <Link as={GatsbyRouter} variant="basic" to="/" mx="1rem">
            Projetos
          </Link>
          <Link as={GatsbyRouter} to="/sobre" mx="1rem">
            Sobre
          </Link>
          <Link as={GatsbyRouter} to="/contato" mx="1rem">
            Contato
          </Link>
        </Box>
        <Menu>
          <MenuButton
            display={["inline", "inline", "none"]}
            as={IconButton}
            aria-label="Options"
            icon={<FiMenu size="3rem" />}
            size="xl"
            variant="text"
          />
          <MenuList display={["inherit", "inherit", "none"]}>
            <MenuItem>
              <Link as={GatsbyRouter} to="/" fontSize="1.6rem" mx="1rem">
                Projetos
              </Link>
            </MenuItem>
            <MenuItem>
              <Link as={GatsbyRouter} to="/sobre" fontSize="1.6rem" mx="1rem">
                Sobre
              </Link>
            </MenuItem>
            <MenuItem>
              <Link as={GatsbyRouter} to="/contato" fontSize="1.6rem" mx="1rem">
                Contato
              </Link>
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
      <Box m="auto" w={["100%", "100%", "100%", "75%"]} maxW={BREAKPOINTS["2xl"]}>
        <Box
          display={["none", "none", "none", "initial"]}
          position="fixed"
          w="32px"
          h="32px"
          borderRadius="50%"
          border="4px solid"
          borderColor="gray.700"
          bottom="32px"
          left="32px"
          right={[0, 0, 0, 0, 0, "1888px"]}
        />
        <Box mx={["4px", "8px", "16px", 0]} my={["4px", "8px", "16px"]}>
          {children}
        </Box>
      </Box>
    </>
  )
}

function UrutauLogo() {
  return (
    <svg width="120.938" height="47.973" viewBox="0 0 3426 1359">
      <image
        id="Layer_0"
        data-name="Layer 0"
        x="59"
        y="9"
        width="3308"
        height="1342"
        xlinkHref="data:img/png;base64,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"
      />
    </svg>
  )
}
